<template>
  <div class="header" />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Header'
})
</script>

<style lang="scss">
.header {
  display: flex;
  align-items: center;
  width: 100%;
  height: 49px;
  background: url('../assets/logo.png') no-repeat center center;
  background-size: auto 100%;
}
</style>
